import { Component, OnInit } from '@angular/core';
import { take } from 'rxjs/operators';
import { SageTaxCode } from '../../models/sage-export.model';
import { SageExportService } from '../../services/sage-export.service';

@Component({
    selector: 'app-sage-tax-codes',
    templateUrl: './sage-tax-codes.component.html',
    styleUrls: ['./sage-tax-codes.component.scss'],
    standalone: false
})
export class SageTaxCodesComponent implements OnInit {

  taxCodes: SageTaxCode[] = [];

  loading: boolean = true;

  /** Per row, keyed by tax type id, so one row's failure does not report against another. */
  saved: { [id: number]: boolean } = {};
  errors: { [id: number]: string } = {};
  saving: { [id: number]: boolean } = {};

  isError: boolean = false;

  constructor(private sageExportService: SageExportService) { }

  ngOnInit(): void {
    this.load();
  }

  load() {
    this.loading = true;

    this.sageExportService.getTaxCodes()
    .pipe(take(1))
    .subscribe({
      next: (data: SageTaxCode[]) => {
        this.taxCodes = data ? data : [];
        this.loading = false;
      },
      error: (e: any) => {
        this.loading = false;

        if (e.status === 401 || e.status === 403) {
          return;
        }

        this.isError = true;
      }
    })
  }

  /** No dirty tracking: one row, one save, so what was sent is what is on that row. */
  save(taxCode: SageTaxCode) {
    this.saved[taxCode.id] = false;
    this.errors[taxCode.id] = '';
    this.saving[taxCode.id] = true;

    this.sageExportService.setTaxCode(taxCode.id, taxCode.sageCode)
    .pipe(take(1))
    .subscribe({
      next: () => {
        this.saving[taxCode.id] = false;
        this.saved[taxCode.id] = true;
      },
      error: (e: any) => {
        this.saving[taxCode.id] = false;

        if (e.status === 401 || e.status === 403) {
          return;
        }

        const faults: string[] = this.sageExportService.faultsFrom(e);

        this.errors[taxCode.id] = faults.length > 0
          ? faults.join(' ')
          : 'Could not save this code. Please try again.';
      }
    })
  }

  formatRate(rate: number): string {
    if (rate === null || rate === undefined) {
      return '—';
    }

    return Number(rate) + '%';
  }

  /** A blank code is the state that refuses a whole batch, so it is marked rather than left bare. */
  isUnmapped(taxCode: SageTaxCode): boolean {
    return !taxCode.sageCode || String(taxCode.sageCode).trim() === '';
  }

  get unmappedCount(): number {
    return this.taxCodes.filter((t: SageTaxCode) => this.isUnmapped(t)).length;
  }
}
